import { isEmpty } from '../../../utility/validation';

const fields = [
  {
    name: 'name',
    type: 'text',
    label: 'name',
    required: true,
    defaultValue: '',
    validators: [
      {
        translationKey: 'required',
        validator: isEmpty,
      },
    ],
  },
];

export default fields;
